import { useSyncExternalStore } from 'react'

import {
  currentLauncherPosition,
  inBottomLeftCorner,
  subscribeLauncherPosition,
} from './launcherPosition'

/**
 * Whether the "Ask AI" launcher is parked in the bottom-left corner, kept
 * current as it is dragged or moved by keyboard — so the toasts, which sit
 * bottom-left to stay clear of it, can move to the other corner.
 */
export function useLauncherInBottomLeft(): boolean {
  return useSyncExternalStore(
    subscribeLauncherPosition,
    () => inBottomLeftCorner(currentLauncherPosition()),
    () => false,
  )
}
